import { create } from 'zustand'

export interface ChatEntry {
  readonly id: string
  readonly mine: boolean
  readonly text: string
  /**
   * 发送方的显示名。房主在转发时按自己的「peerId → 名字」表改写，
   * 因此这个字段总是权威的；缺省时界面回退到「我 / 对方」语义。
   */
  readonly name?: string
  readonly system?: boolean
}

export interface ChatState {
  messages: readonly ChatEntry[]
  unread: number
  push(entry: { mine: boolean; text: string; name?: string; system?: boolean }): void
  markRead(): void
  clear(): void
}

export const MAX_CHAT_MESSAGES = 200

let sequence = 0

export const useChat = create<ChatState>()((set) => ({
  messages: [],
  unread: 0,
  push: (entry) =>
    set((state) => {
      sequence += 1
      const next: ChatEntry = {
        id: `chat-${sequence}`,
        mine: entry.mine,
        text: entry.text,
        name: entry.name,
        system: entry.system,
      }
      return {
        messages: [...state.messages, next].slice(-MAX_CHAT_MESSAGES),
        unread: entry.mine ? state.unread : state.unread + 1,
      }
    }),
  markRead: () => set({ unread: 0 }),
  clear: () => set({ messages: [], unread: 0 }),
}))
